import React from "react";
import assign from "lodash/assign";
import get from "lodash/get";
import set from "lodash/set";
import marked from "marked";
import moment from "moment";
import Select from "react-select";
import {
  Checkbox,
  TextField,
  RaisedButton,
  RadioButtonGroup,
  RadioButton
} from "material-ui";
import { colors } from "material-ui/styles";

import WorkingIndicator from "./partials/working-indicator.jsx";
import Label from "./partials/label.jsx";
import BasicHtmlField from "./partials/basic-html-field.jsx";
import LinkLike from "./partials/link-like.jsx";
import BackButton from "./partials/back-button.jsx";
import * as util from "../util";

import InfoNotice from "./partials/info-notice.jsx";

import ListTargetBuilder from "./partials/list-target-builder.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import MailingActions from "../actions/MailingActions";
import MailingStore from "../stores/MailingStore";
import EventActions from "../actions/EventActions";
import EventBucketStore from "../stores/EventBucketStore";
import EventStore from "../stores/EventStore";
import PassBucketActions from "../actions/PassBucketActions";
import PassBucketStore from "../stores/PassBucketStore";
import CouponActions from "../actions/CouponActions";
import CouponStore from "../stores/CouponStore";
import TagActions from "../actions/TagActions";
import TagStore from "../stores/TagStore";
import { Link } from "react-router";
import config from "../config.js";
import UserStore from "../stores/UserStore";

class Mailing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mailing: null,
      dirty: false,
      isWorking: false,
      isFetchingMailing: false,
      values: {},
      lastUpdated: null,
      previewRecipients: false,
      testEmailRecipient: ""
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.onChangeDropdown = this.onChangeDropdown.bind(this);
    this.save = this.save.bind(this);
    this.delete = this.delete.bind(this);
    this.send = this.send.bind(this);
    this.clone = this.clone.bind(this);
    this.previewRecipients = this.previewRecipients.bind(this);
    this.downloadRecipients = this.downloadRecipients.bind(this);
    this.testSend = this.testSend.bind(this);
    this.onChangeTestEmail = this.onChangeTestEmail.bind(this);
  }

  static getStores() {
    return [
      MailingStore,
      EventStore,
      PassBucketStore,
      CouponStore,
      EventBucketStore
    ];
  }

  static getPropsFromStores() {
    return {
      getMailingById: MailingStore.getMailingById,
      errorMessage: MailingStore.getState().errorMessage,
      isEditing: MailingStore.getState().isEditing,
      getEventBucketById: EventBucketStore.getEventBucketById
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      sentNotice: {
        margin: "0 auto",
        width: 295,
        backgroundColor: "rgba(255, 0, 0, 0.54)",
        opacity: 1,
        padding: 13,
        fontSize: 20,
        textAlign: "center",
        position: "absolute",
        left: 0,
        right: 0,
        top: 150
      },
      actions: {
        marginTop: 10
      },
      a: {
        color: colors.lightBlue700,
        textDecoration: "underline",
        cursor: "pointer"
      },
      h3: {
        marginTop: 30,
        marginBottom: 10
      },
      label: {
        fontSize: 13,
        color: "rgba(33,33,33,0.5)",
        marginTop: 11,
        marginBottom: -12,
        fontWeight: "initial"
      },
      sentLabel: {
        fontSize: 13,
        color: "rgba(33,33,33,0.5)",
        marginTop: 11,
        marginBottom: -3
      },
      sentContent: {
        border: "1px solid #ccc",
        padding: 5,
        overflow: "auto"
      },
      error: {
        color: "red",
        marginTop: 10
      },
      readyToSend: {
        marginTop: 20,
        marginBottom: 20
      },
      previewSection: {
        display: "flex",
        flexDirection: "column"
      }
    };
  }

  onChange(id, e, checked) {
    this.onChangeValue(
      id,
      typeof checked !== "undefined" ? !this.state.values[id] : e.target.value
    );
  }

  onChangeDropdown(id, e, index, item) {
    this.onChangeValue(id, item.payload);
  }

  onChangeValue(id, value) {
    // Persist promotional state when resetting query
    if (id === "query") {
      value.promotional = this.state.values.query.promotional;
    }

    this.state.dirty = true;
    set(this.state.values, id, value);
    this.setState(this.state);
  }

  onChangeTestEmail(value) {
    this.setState({ testEmailRecipient: value });
  }

  save() {
    var values = assign({}, this.state.values);
    this.setState({
      isWorking: true,
      lastUpdated: this.state.mailing.updated_at
    });
    MailingActions.edit(this.props.params.mailingId, values);
  }

  clone() {
    this.context.router.replace(
      `/event_buckets/${this.props.params.eventBucketId}/mailings/clone/${this.props.params.mailingId}`
    );
  }

  send() {
    let bucket = this.state.mailing.event_bucket;
    if (
      window.confirm(
        `Are you sure? This message, with the subject "` +
          `${this.state.mailing.subject}", will be sent immediately ` +
          `to ${this.state.mailing.recipients.length} recipients.`
      )
    ) {
      this.setState({
        isWorking: true,
        lastUpdated: this.state.mailing.updated_at
      });
      MailingActions.send(this.props.params.mailingId);
    }
  }

  testSend() {
    this.sendTestMail();
  }

  delete() {
    let bucket = this.state.mailing.event_bucket;
    if (window.confirm("Are you sure?")) {
      MailingActions.delete(this.props.params.mailingId);
      this.context.router.push(`/event_buckets/${bucket}/mailings`);
    }
  }

  componentDidMount() {
    this.setState({ isFetchingMailing: true }, () => {
      MailingActions.fetchOne.defer(this.props.params.mailingId);
      this.componentWillReceiveProps(this.props);
    });

    PassBucketActions.fetchAllForEventBucket(this.props.params.eventBucketId);
    EventActions.fetchAllForBucket(this.props.params.eventBucketId);
    CouponActions.fetchAllForBucket(this.props.params.eventBucketId);
    TagActions.fetchAllForBucket(this.props.params.eventBucketId);
  }

  componentWillReceiveProps(newProps) {
    var mailing = newProps.getMailingById(newProps.params.mailingId);

    if (!this.state.isFetchingMailing && (!mailing || !mailing.recipients)) {
      MailingActions.clearErrors();
      MailingActions.fetchOne.defer(newProps.params.mailingId);
      this.setState({ isFetchingMailing: true });
    } else if (mailing && mailing.recipients) {
      this.setState({ isFetchingMailing: false, mailing: mailing });
    }

    if (this.state.isWorking && !newProps.isEditing) {
      this.setState({ isWorking: false });
    }

    if (
      Object.keys(this.state.values).length === 0 ||
      this.state.mailing.id !== newProps.params.mailingId ||
      (this.state.isWorking && mailing.updated_at !== this.state.lastUpdated)
    ) {
      this.setState({
        mailing,
        isWorking: false,
        dirty: false,
        values: mailing
          ? {
              subject: mailing.subject || "",
              content: mailing.content || "",
              query: {
                all_attendees: get(mailing, "query.all_attendees", false),
                all_standalone_tickets_only: get(
                  mailing,
                  "query.all_standalone_tickets_only",
                  false
                ),
                event: get(mailing, "query.event", []),
                pass_bucket: get(mailing, "query.pass_bucket", []),
                coupon: get(mailing, "query.coupon", []),
                tag: get(mailing, "query.tag", []),
                promotional: get(mailing, "query.promotional", false)
              }
            }
          : {}
      });
    }
  }

  sendTestMail = async () => {
    try {
      await fetch(
        `${config.endpoint}mailings/${
          this.props.params.mailingId
        }/sendTestMailing?${UserStore.makeApiKeyQueryString()}`,
        {
          method: "POST",
          body: JSON.stringify({
            testRecipient: this.state.testEmailRecipient
          }),
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
      window.alert(`We sent a test email to ${this.state.testEmailRecipient}`);
      this.setState({ testEmailRecipient: "" });
    } catch (err) {
      window.alert(`Failed to send a test email: ${err}`);
    }
  };

  previewRecipients() {
    this.setState({ previewRecipients: !this.state.previewRecipients });
  }

  downloadRecipients() {
    util.clientSideDownload(
      `mailing-${this.state.mailing.id}-${util.snakeCase(
        this.state.mailing.subject
      )}.csv`,
      "text/csv",
      util.makeCsv(this.state.mailing.recipients.map(r => [r.name, r.email]))
    );
  }

  _makeRecipientsList(recipients) {
    return recipients
      .map(r => {
        return r.name ? `${r.name} <${r.email}>` : r.email;
      })
      .join(", ");
  }

  render() {
    var styles = this.getStyles();

    const eventBucket = this.props.getEventBucketById(
      this.props.params.eventBucketId
    );

    if (
      !this.state.mailing ||
      !this.state.mailing.recipients ||
      this.state.isFetchingMailing ||
      MailingStore.getState().isFetching ||
      this.state.isWorking
    ) {
      return <WorkingIndicator fullPage={true} />;
    }

    let okayToSend =
      !this.state.dirty &&
      this.state.mailing.recipients &&
      this.state.mailing.recipients.length;

    return (
      <div>
        <div>
          <BackButton
            label="Mailings"
            style={{ marginBottom: 10 }}
            location={`/event_buckets/${this.props.params.eventBucketId}/mailings`}
          />
        </div>
        {this.state.mailing.sent_at ? (
          <div>
            <div style={{ color: "green" }}>
              This mailing has been sent. It cannot be modified. The following
              is preserved as a record of the mailing.
            </div>
            <h2 style={styles.sentLabel}>Send date</h2>
            {moment(this.state.mailing.sent_at).format("LLLL")}
            <h2 style={styles.sentLabel}>
              Recipients{" "}
              <LinkLike
                style={{ fontWeight: "normal" }}
                onTouchTap={this.previewRecipients}
              >
                {this.state.previewRecipients ? "hide list" : "show list"}
              </LinkLike>
            </h2>
            <div>
              {ListTargetBuilder._makeRecipientDescription(
                this.state.mailing.query,
                this.props.eventBucketId,
                {
                  PassBucketStore,
                  EventStore,
                  CouponStore,
                  EventBucketStore,
                  TagStore
                }
              )}
            </div>
            {this.state.previewRecipients && (
              <div>
                {this._makeRecipientsList(this.state.mailing.recipients)}
                <div>
                  <LinkLike onTouchTap={this.downloadRecipients}>
                    Download as CSV
                  </LinkLike>{" "}
                  ({this.state.mailing.recipients.length} total)
                </div>
              </div>
            )}
            <h2 style={styles.sentLabel}>Subject</h2>
            {this.state.mailing.subject}
            <h2 style={styles.sentLabel}>Content</h2>
            <div
              style={styles.sentContent}
              className="tenant-injected-html"
              dangerouslySetInnerHTML={{ __html: this.state.mailing.content }}
            />
            {/* <div style={styles.actions}>
              <RaisedButton label="Duplicate mailing" onTouchTap={this.clone} />
            </div> */}
          </div>
        ) : (
          <div>
            <InfoNotice style={{ marginTop: 10 }}>
              Check out our{" "}
              <a
                href="http://help.eventive.org/mailings/create-mailings"
                target="_blank"
              >
                guide to creating mailings
              </a>
              .
            </InfoNotice>
            <div>
              <div>
                <TextField
                  value={get(this.state, "values.subject", "")}
                  floatingLabelText="Subject"
                  style={{ width: 400 }}
                  onChange={e => this.onChangeValue("subject", e.target.value)}
                />
              </div>
              <ListTargetBuilder
                label="Audience"
                eventBucketId={this.props.params.eventBucketId}
                stores={{
                  EventStore,
                  CouponStore,
                  PassBucketStore,
                  EventBucketStore,
                  TagStore
                }}
                query={get(this.state, "values.query")}
                onChange={this.onChangeValue}
              />
              <Label>Mailing type</Label>
              <RadioButtonGroup
                name="mailing_type"
                valueSelected={
                  get(this.state.values, "query.promotional")
                    ? "promotional"
                    : "transactional"
                }
                onChange={(e, v) =>
                  this.onChangeValue(
                    "query.promotional",
                    v === "promotional" ? true : false
                  )
                }
              >
                <RadioButton
                  value="transactional"
                  label={
                    <span>
                      Transactional{" "}
                      <i>
                        (for essential updates, instructions, and event changes;
                        sent to all matching recipients)
                      </i>
                    </span>
                  }
                />
                <RadioButton
                  value="promotional"
                  label={
                    <span>
                      Promotional{" "}
                      <i>
                        (for nonessential messages; skips recipients who have
                        unsubscribed from promotions)
                      </i>
                    </span>
                  }
                />
              </RadioButtonGroup>
              <div>
                <BasicHtmlField
                  value={get(this.state, "values.content", "")}
                  label="Message"
                  onChange={v => this.onChangeValue("content", v)}
                  withImages={true}
                />
              </div>
            </div>
            <div>
              {!this.state.dirty ? (
                <div style={styles.previewSection}>
                  <Label>Previews</Label>
                  <div>
                    <TextField
                      floatingLabelText="Test Email Recipient"
                      type="email"
                      onChange={e => this.onChangeTestEmail(e.target.value)}
                      style={{ marginRight: "8px", marginTop: "-40px" }}
                      value={this.state.testEmailRecipient}
                    />
                    <RaisedButton
                      label="Send Test Email"
                      onClick={this.testSend}
                      style={{ width: "fit-content" }}
                      disabled={this.state.testEmailRecipient === ""}
                    />
                  </div>
                  <text style={{ marginTop: "8px" }}>
                    Preview mailing{" "}
                    <Link
                      to={`/event_buckets/${this.props.params.eventBucketId}/mailings/${this.props.params.mailingId}/preview`}
                    >
                      here
                    </Link>
                  </text>
                </div>
              ) : (
                "Save changes before you can view a preview of your mailing"
              )}
            </div>
            <div style={styles.readyToSend}>
              <div>
                {okayToSend ? (
                  <span>
                    Ready to send to {this.state.mailing.recipients.length}{" "}
                    recipients (
                    <LinkLike onTouchTap={this.previewRecipients}>
                      {this.state.previewRecipients ? "hide list" : "show list"}
                    </LinkLike>
                    ).
                  </span>
                ) : this.state.dirty ||
                  !this.state.mailing.recipients ||
                  this.state.mailing.recipients.length ? (
                  "Please save before sending."
                ) : (
                  "Cannot send: 0 recipients targeted."
                )}
              </div>
              {okayToSend && this.state.previewRecipients ? (
                <div>
                  <div>
                    {this._makeRecipientsList(this.state.mailing.recipients)}
                  </div>
                  <div>
                    <LinkLike onTouchTap={this.downloadRecipients}>
                      Download as CSV
                    </LinkLike>
                  </div>
                </div>
              ) : null}
            </div>
            {this.props.errorMessage ? (
              <div style={styles.error}>{this.props.errorMessage}</div>
            ) : null}
            <div style={styles.actions}>
              <RaisedButton
                label={this.state.dirty ? "Save changes" : "No changes to save"}
                primary={true}
                disabled={!this.state.dirty}
                onTouchTap={this.save}
              />
              <RaisedButton
                label="Delete mailing"
                onTouchTap={this.delete}
                style={{ marginLeft: 7 }}
              />
              <RaisedButton
                label="Send mailing"
                disabled={!okayToSend}
                onTouchTap={this.send}
                style={{ marginLeft: 7 }}
              />
              {/* <RaisedButton
                label="Duplicate mailing"
                onTouchTap={this.clone}
                style={{ marginLeft: 7 }}
              /> */}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connectToStores(Mailing);



// WEBPACK FOOTER //
// ./src/app/components/mailing.jsx